import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Icons } from "../../assets/icon";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Event } from "@mui/icons-material";

interface CloverCardStripProps {
  date: string;
  chipAmount: number;
  time: string;
  isHovered: boolean;
}

export default function CloverCardStrip(props: CloverCardStripProps) {
  const { chipAmount, date, time, isHovered } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack
      spacing={1}
      sx={{
        mb: isHovered ? 2 : 1,
        flexWrap: "wrap",
        rowGap: { xs: 0.5, sm: 1, md: 2 },
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          display: "flex",
          padding: isMobile
            ? "0px"
            : "var(--spacing-1x) var(--spacing-2x) var(--spacing-1x) var(--spacing-1x)",
          alignItems: "flex-start",
          gap: " var(--spacing-1x)",
          borderRadius: "var(--spacing-8x)",
          background: { xs: "none", sm: "var(--primary-100)" },
          height: { xs: "auto", md: "28px" },
          flexWrap: "wrap",
          flexDirection: "row",
        }}
      >
        {/* date */}
        <Box
          gap="2px"
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "2px var(--spacing-1x)",
              gap: "var(--Spacing-1x)",
              borderRadius: "16px",
              background: "var(--neutralWhite)",
            }}
          >
            <Event
              sx={{
                color: "var(--primary-600)",
                stroke: "1.33px",
                fontSize: { xs: 13, sm: 13, md: 18 },
                height: "16px",
                width: "16px",
              }}
            />
          </Box>
          <Typography
            sx={{
              alignItems: "flex-start",
              font: "var(--body-xs)",
              color: "var(--neutral-1000)",
              fontSize: {
                xs: "10px",
                sm: "12px",
              },
            }}
          >
            {date}
          </Typography>
        </Box>
        {/* time */}
        <Box
          gap="2px"
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "2px var(--spacing-1x)",
              gap: "var(--Spacing-1x)",
              borderRadius: "16px",
              background: "var(--neutralWhite)",
            }}
          >
            <AccessTimeIcon
              sx={{
                color: "var(--primary-600)",
                stroke: "1.33px",
                fontSize: { xs: 13, sm: 13, md: 18 },
                height: "16px",
                width: "16px",
                "& .MuiSvgIcon-root ": {
                  height: "none !important",
                  width: "none",
                },
              }}
            />
          </Box>
          <Typography
            sx={{
              alignItems: "flex-start",
              font: "var(--body-xs)",
              color: "var(--neutral-1000)",
              fontSize: {
                xs: "10px",
                sm: "12px",
              },
            }}
          >
            {time}
          </Typography>
        </Box>
        {/* coins */}
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          gap="2px"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "2px var(--spacing-1x)",
              gap: "var(--Spacing-1x)",
              borderRadius: "16px",
              background: "var(--neutralWhite)",
            }}
          >
            <Icons.Coin />
          </Box>
          <Typography
            sx={{
              font: "var(--body-xs)",
              color: "var(--neutral-1000)",
              fontSize: {
                xs: "10px",
                sm: "12px",
              },
            }}
          >
            {chipAmount}
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
}
